import { ROLES } from '@/constantes';

export const isSuperAdmin = (usuario) => {
    return usuario?.rol?.id_rol === ROLES.SUPERADMIN;
};


export const getLoggedUserRoleId = () => {
    const userDataString = localStorage.getItem('userData');
    if (userDataString) {
        try {
            const userData = JSON.parse(userDataString);
            return userData?.rol?.id_rol || null;
        } catch (e) {
            console.error("Error al obtener ID de rol:", e);
        }
    }
    return null;
};